import { render, staticRenderFns } from "./ContentOfferView.vue?vue&type=template&id=f688467a&"
import script from "./ContentOfferView.vue?vue&type=script&lang=js&"
export * from "./ContentOfferView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports